/* TENSO — accordions: smooth open/close, one at a time.

   WHY <details> IS KEPT
   The markup stays native <details>/<summary>. If this file never loads, every
   panel still opens and closes — you lose the animation and the exclusivity,
   not the content. Nothing here decides whether content exists: no CSS hides the
   panel in its base state, so a failed script cannot strand copy invisible.

   HOW THE ANIMATION WORKS
   <details> has no animatable height, so opening is driven manually: set open
   first (content is measurable and present), then transition the panel from 0 to
   its scrollHeight and hand height back to auto. Closing runs the reverse and
   sets open=false only once the panel has actually collapsed — otherwise the
   browser removes the content mid-transition and it vanishes rather than closes.

   The cleanup is on a setTimeout, not transitionend. transitionend does not fire
   in a background tab or when a transition is interrupted, and a missed event
   would leave a panel stuck at height:0 with open=true — content present but
   invisible. The timeout always runs.

   ASYMMETRIC EASING — this is the fix for a close that felt like it lagged.
   --ease-quiet is an ease-OUT: fast start, long slow tail. On the way open that
   tail is the settle, and it is the whole character of the brand's motion. On
   the way closed it is dead time — the panel spends its last ~100ms creeping
   through a few pixels while the user has already moved on, which reads as the
   interface being slow rather than gentle.

   Closing therefore uses an ease-IN curve and a shorter duration: it leaves
   gently and finishes decisively, so the panel is gone when it looks gone.
   Both curves stay under 1 on the y axis — no overshoot, per the brand lock.
*/
(function(){
  "use strict";

  var DUR_OPEN   = 360;
  var DUR_CLOSE  = 240;
  var EASE_OPEN  = 'cubic-bezier(.22,.61,.36,1)';   /* ease-out — settles */
  var EASE_CLOSE = 'cubic-bezier(.5,0,.75,.55)';    /* ease-in — clears out */
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function panelOf(d){
    var s = d.querySelector(':scope > summary');
    return s ? s.nextElementSibling : null;
  }

  function clear(p){
    p.style.transition = '';
    p.style.height = '';
    p.style.overflow = '';
  }

  function expand(d){
    var p = panelOf(d);
    d.open = true;
    if(!p || REDUCE) return;
    var target = p.scrollHeight;
    p.style.overflow = 'hidden';
    p.style.height = '0px';
    void p.offsetHeight;                 /* commit the start value synchronously */
    p.style.transition = 'height ' + DUR_OPEN + 'ms ' + EASE_OPEN;
    p.style.height = target + 'px';
    window.setTimeout(function(){ clear(p); }, DUR_OPEN + 60);
  }

  function collapse(d){
    var p = panelOf(d);
    if(!p || REDUCE){ d.open = false; return; }
    p.style.overflow = 'hidden';
    p.style.height = p.scrollHeight + 'px';
    void p.offsetHeight;
    p.style.transition = 'height ' + DUR_CLOSE + 'ms ' + EASE_CLOSE;
    p.style.height = '0px';
    window.setTimeout(function(){
      clear(p);
      d.open = false;                    /* only after it has visually closed */
    }, DUR_CLOSE);
  }

  /* Delegated, so it survives theme-editor section reloads. */
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var summary = e.target.closest('summary');
    if(!summary) return;
    var d = summary.parentElement;
    if(!d || d.tagName !== 'DETAILS' || !d.classList.contains('acc')) return;

    e.preventDefault();

    if(d.open){ collapse(d); return; }

    /* One at a time — same behaviour as the two drawers. Scoped to siblings, so
       two separate accordion groups on one page stay independent. */
    var group = d.parentElement;
    if(group){
      [].slice.call(group.children).forEach(function(sib){
        if(sib !== d && sib.tagName === 'DETAILS' && sib.classList.contains('acc') && sib.open){
          collapse(sib);
        }
      });
    }
    expand(d);
  });
})();
